import React from 'react';
import PropTypes from 'prop-types';
import type { LoaderProps } from './Loader.types';
import './loader.scss';

const Loader = ({ size, className }: LoaderProps) => {
  return (
    <div
      className={`loader ${className ? className : ''}`}
      data-testid="loader"
    >
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        className="loader__svg"
        data-testid="loader__svg"
      >
        <circle
          className="loader__circle"
          data-testid="loader__circle"
          cx="50"
          cy="50"
          r="45"
        />
      </svg>
    </div>
  );
};

Loader.propTypes = {
  /**
* Size of loader
*/
  size: PropTypes.number,
  /**
* Classes of loader
*/
  className: PropTypes.string,
};

Loader.defaultProps = {
  size: 50,
};

export default Loader;